import {
  AuthSignInPage,
  AuthSignUpPage,
  AuthForgotPasswordPage,
  AuthChangePasswordPage,
} from '@/app/pages/authentication';
import { CenterBox } from '@/app/components/container/center-box';
import { IgnoreBox } from '@/app/components/container/protected-box';
import { Outlet, Route, Routes } from 'react-router-dom';
import { FlexBox } from '@/app/components/container/flex-box';
export function AuthRoute() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <IgnoreBox>
            <FlexBox>
              <CenterBox>
                <Outlet />
              </CenterBox>
            </FlexBox>
          </IgnoreBox>
        }
      >
        <Route path="signup" element={<AuthSignUpPage />} />
        <Route index path="/" element={<AuthSignInPage />} />
        <Route index path="signin" element={<AuthSignInPage />} />
        <Route path="forgot-password" element={<AuthForgotPasswordPage />} />
        {/* Supabase's recovery link lands here with the access token in the
            URL fragment (#access_token=...&type=recovery), not a path param.
            The old /:token path is kept mapped to the same page in case a
            pre-migration reset email is still in someone's inbox. */}
        <Route path="change-password" element={<AuthChangePasswordPage />} />
        <Route
          path="change-password/:token"
          element={<AuthChangePasswordPage />}
        />
      </Route>
    </Routes>
  );
}
